export const sortByOrder = <T extends { order?: number }>(a: T, b: T) => {
  const orderA = a.order ?? Number.MAX_SAFE_INTEGER;
  const orderB = b.order ?? Number.MAX_SAFE_INTEGER;

  return orderA - orderB;
};

export const moveToFront = <T>(list: T[], isFirst: (item: T) => boolean): T[] => {
  const index = list.findIndex(isFirst);

  return index > 0 ? [list[index], ...list.slice(0, index), ...list.slice(index + 1)] : list;
};

// A frozen delivery ranking (DEV-2422) replaces the market order. Options it doesn't know go last, in
// market order, as does everything when there is no ranking.
export const sortByRank = (ranked: string[] | undefined) => {
  const positionOf = (name: string) => (ranked?.includes(name) ? ranked.indexOf(name) : Number.MAX_SAFE_INTEGER);

  return <T extends { name: string; order?: number }>(a: T, b: T) => positionOf(a.name) - positionOf(b.name) || sortByOrder(a, b);
};
